import React from 'react';
import { withRouter } from 'react-router-dom';
import { ApiDataContext } from 'contexts/ApiDataContext';
import { CategoryFileArchiveContext } from 'contexts/CategoryFileArchiveContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import {
	HeaderPlaceholder,
	UploadWrapper,
	Wrapper,
} from './CategoryData.styles';
import { UploadCategoryStateContext } from 'contexts/UploadCategoryStateContext';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import UploadCategoryData from '../../../Data/components/UploadCategoryData';
import FileList from 'Data/components/FileList';
export class CategoryData extends React.Component {
	render() {
		const {
			status,
			refetchCategoryState,
			fileArchive,
			fetchFileArchive,
			isCategoryStateFetching,
		} = this.props;

		const fileList = fileArchive;
		return (
			<Wrapper>
				<UploadWrapper>
					{isCategoryStateFetching ? (
						<ApLoaderDefault />
					) : (
						<>
							<HeaderPlaceholder />
							<UploadCategoryData
								status={status}
								refetchCategoryState={refetchCategoryState}
								fetchFileArchive={fetchFileArchive}
							/>
						</>
					)}
				</UploadWrapper>

				<FileList data={fileList} />
				{/* <ExampleDownload>
					<span>
						Please be sure you are uploading an Raw Data in CSV format. You can
						download an example of the expected format below.
					</span>
					<DownloadLink
						href={getTempLabourTemplate()}
						target="_blank"
						download="template.csv"
					>
						Download example
					</DownloadLink>
				</ExampleDownload> */}
			</Wrapper>
		);
	}
}

export default withRouter(props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<ApiDataContext.Consumer>
				{({ clearApiCache }) => (
					<UploadCategoryStateContext.Consumer>
						{({
							categoryStatus,
							refetchCategoryState,
							isCategoryStateFetching,
						}) => (
							<CategoryFileArchiveContext.Consumer>
								{({
									fileArchive,
									refetch: fetchFileArchive,
									isFetching: isCategoryFilesFetching,
								}) => (
									<CategoryData
										status={categoryStatus}
										refetchCategoryState={refetchCategoryState}
										fileArchive={fileArchive}
										fetchFileArchive={fetchFileArchive}
										isCategoryFilesFetching={isCategoryFilesFetching}
										isCategoryStateFetching={isCategoryStateFetching}
										clearApiCache={clearApiCache}
										permissions={permissions}
										{...props}
									/>
								)}
							</CategoryFileArchiveContext.Consumer>
						)}
					</UploadCategoryStateContext.Consumer>
				)}
			</ApiDataContext.Consumer>
		)}
	</PermissionsContext.Consumer>
));
